import { createTheme } from '@mui/material/styles';
import { muiColorsOverrideHandler } from './muiColorsOverrideHandler';
import { muiThemeOverrideHandler } from './theme';

type BrandColors = {
  primaryColor?: string;
  secondaryColor?: string;
};

/**
 * Builds the full MUI theme, optionally overriding primary/secondary
 * colors from the institute branding API.
 *
 * Falls back to the static `muiThemeOverrideHandler` when no overrides
 * are provided so callers can use it as a stable reference.
 */
export const createBrandedTheme = ({ primaryColor, secondaryColor }: BrandColors = {}) => {
  if (!primaryColor && !secondaryColor) {
    return muiThemeOverrideHandler;
  }

  const colorBase = createTheme(muiColorsOverrideHandler, {
    palette: {
      ...(primaryColor
        ? {
            primary: {
              main: primaryColor,
              contrastText: '#FFFFFF',
            },
          }
        : {}),
      ...(secondaryColor
        ? {
            secondary: {
              main: secondaryColor,
              contrastText: '#FFFFFF',
            },
          }
        : {}),
    },
  });

  return createTheme(colorBase, {
    breakpoints: muiThemeOverrideHandler.breakpoints,
    spacing: muiThemeOverrideHandler.spacing,
    components: muiThemeOverrideHandler.components,
  });
};
